import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MessageModule } from '../modelo/message/message.module';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})


export class LoginService {

  constructor(private http: HttpClient) { }
  
  guardar(mensaje:MessageModule){
    console.log(environment.apiUrlMaxipan+"chat.php",JSON.stringify(mensaje));
    return  this.http.post(environment.apiUrlMaxipan+"chat.php",JSON.stringify(mensaje)); 
  }


  cerra_chat(sala){
   return  this.http.get(environment.apiUrlMaxipan+"chat.php?cerrar=S&sala2="+sala); 
  }
  validarUsuario(email: string, clave: string)
  {
  console.log(environment.apiUrlFlp+"/login/"+clave+"&"+"email="+email);
 
    return this.http.get(environment.apiUrlMaxipan+"login.php?usuario="+email+"&clave="+clave); 
  }


  locales(id_pais:string)
  {

    return this.http.get(environment.apiUrlMaxipan+"/locales.php?id_pais="+id_pais); 
  }

  localestodos()
  {

    return this.http.get(environment.apiUrlMaxipan+"/locales.php"); 
  }


  historyChat(sala:string)
  {

    return this.http.get(environment.apiUrlMaxipan+"/chat.php?sala="+sala); 
  }
 
  contarMensajesAdministrador(pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/chat.php?admin="+pais); 
  }


  verficarMensajaMovil(idlocal,pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/locales_movil.php?eventoLocal=1&local="+idlocal+"&id_pais="+pais); 
  }

  contarMensajesLocal(local)
  {

    return this.http.get(environment.apiUrlMaxipan+"/chat.php?local="+local); 
  }
  
    
  
}
